import { Routes } from "@angular/router";
import { AuthGuard } from "../../auth/helpers";
import { InvoiceRowTypeComponent } from "./pages/invoice-row-type/invoice-row-type.component";
import { InvoiceDocumentTypeComponent } from "./pages/invoice-document-type/invoice-document-type.component";
import { InvoicePaymentTypeComponent } from "./pages/invoice-payment-type/invoice-payment-type.component";
import { InvoiceSendedComponent } from "./pages/invoice/sended/invoice-sended.component";
import { InvoiceGeneratedComponent } from "./pages/invoice/generated/invoice-generated.component";
import { InvoiceToCreateComponent } from "./pages/invoice/to-create/invoice-to-create.component";
import { InvoiceServicesComponent } from "./pages/invoice-services/invoice-services.component";
import { InvoiceCompletedComponent } from "./pages/invoice/completed/invoice-completed.component";
import { InvoiceArchivedComponent } from "./pages/invoice/archived/invoice-archived.component";
import InvoiceCreateComponent from "./pages/invoice-create/invoice-create.component";
import { InvoiceDocumentCodeComponent } from "./pages/invoice-document-code/invoice-document-code.component";
import InvoiceEditComponent from "./pages/invoice-edit/invoice-edit.component";
import { CreditNoteCreateComponent } from "./pages/credit-note-create/credit-note-create.component";
import { CreditNoteEditComponent } from "./pages/credit-note-edit/credit-note-edit.component";

const invoiceRoutes: Routes = [
  {
    path: "dashboard/invoice/to-generate", // da generare
    component: InvoiceToCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice/generated", // generate
    component: InvoiceGeneratedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice/sended", // inviate
    component: InvoiceSendedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice/completed", // completate
    component: InvoiceCompletedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice/row-type",
    component: InvoiceRowTypeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice/documents-types",
    component: InvoiceDocumentTypeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice/documents-codes",
    component: InvoiceDocumentCodeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice/payments-types",
    component: InvoicePaymentTypeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice-services",
    component: InvoiceServicesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice/archived",
    component: InvoiceArchivedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice/create/invoice",
    component: InvoiceCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice/create/invoice/:analytics",
    component: InvoiceCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice/create/credit-note",
    component: CreditNoteCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice/edit/invoice/:id",
    component: InvoiceEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/invoice/edit/credit-note/:id",
    component: CreditNoteEditComponent,
    canActivate: [AuthGuard],
  },
];
export default invoiceRoutes;
